import * as pxp from '../lib/pxp'

// https://internal.msmaster.qa.paypal.com/elmo/experiment/148683
export function fixP2PAFCurrencySymbolNotDisplayed() {
  return pxp.isTreatment('Trmt_p2p_fix_currency_symbol_not_displayed')
}
